import blogPost from '../post-card/post-card.vue';
import heroImage from '../../assets/heroImage.jpg?placeholder=true&sizes[]=300,sizes[]=400,sizes[]=800,sizes[]=1000,sizes[]=1400,sizes[]=1800';

export default {
    name: 'About',
    data() {
        return {
            heroImageSrcSet: heroImage.srcSet,
            heroImageSrc: heroImage.src,
            motd: [
                'It\'s supposed to sink.',
                'We measured it...sorta.',
                'How fast is it leaking?'
            ][Math.floor(Math.random() * 3)]
        };
    },
    mounted: function() {
        // show toolbar
        document.getElementById('navBar').style.marginTop = '0px';
        document.body.style.overflow = null;
    },
    computed: {
        posts: function() {
            return this.$store.state.blogPosts;
        }
    },
    components: {
        blogPost
    }
};



// WEBPACK FOOTER //
// ./src/components/about/about.js